import { getToken, getUser, removeSession, setSession } from "@/helpers/auth-helper"
import { useState, useContext, createContext } from "react"

// Initial state
const initialState = {
    user: getUser(),
    token: getToken(),
    setSession: (token, user) => {
        setSession(token, user)
    },
    logout: () => {
        removeSession()
    }
}

// Auth context
export const AuthContext = createContext(initialState)

// Provider
export const AuthProvider = ({ children }) => {
    const [user, setUserState] = useState(getUser())
    const [token, setTokenState] = useState(getToken())

    const setSession = (token, user) => {
        setUserState(user)
        setTokenState(token)
        setSession(token, user)
    }

    const logout = () => {
        removeSession()
    }

    const value = {
        user,
        token,
        setSession,
        logout,
    }

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => {
    return useContext(AuthContext)
}